// extracted by mini-css-extract-plugin
export default {"wrapper":"Reporting_wrapper__YOo0z"};